(function( $ ) {

    $( document ).ready( function() {

        if ($('#flights_search_module.arr_dep_flights_search_module_ari').length > 0) {
            const { __, _x, _n, _nx } = wp.i18n;

            const flightsSearchModule = $('#flights_search_module.arr_dep_flights_search_module_ari');
            const flightsSearchModuleTrigger = $('.arr_dep_flights_search_module_ari #flights_search_module_trigger');
            const flightSearchForm = flightsSearchModule.find( ".arr_dep_form_ari" );

            if ( flightsSearchModuleTrigger.length > 0 ) {

                //mobile
                flightsSearchModuleTrigger.click( function() {

                    $(this).find('.fa-chevron-down').toggleClass('active');

                    flightsSearchModule.find('#flights_search_form_wrap').slideToggle();
                });
                // Original width and height before resize
                var originalWidth = $(window).width();
                function isKeyboard(width) {
                    if (originalWidth === width) {
                        return true;
                    } else {
                        return false;
                    }
                }
                //on window resize, show/hide items
                $(window).resize(function(){
                    const winWidth = window.innerWidth;
                    let resizedWidth = $(window).width();
                    const chevronDown = flightsSearchModuleTrigger.find('.fa-chevron-down');

                    if ( winWidth > 767 ) {

                        flightsSearchModule.find('#flights_search_form_wrap').show();

                    } else {

                        if (!(isKeyboard(resizedWidth))) {
                            flightsSearchModule.find('#flights_search_form_wrap').hide();
                            if (chevronDown.hasClass('active')) {
                                chevronDown.removeClass('active');
                            }
                        }
                    }
                });

                /**
                 * Destinations List Array
                 */
                var data_dest = $('#flights_search_module').attr('data-dest');
                data_dest = JSON.parse(data_dest);

                const destinationsList = [];

                $.each(data_dest, function(index, value) {
                    destinationsList.push(value);
                });

                /**
                 * Airlines List Array
                 */
                var data_aircomp = $('#flights_search_module').attr('data-airlineNames');
                data_aircomp = JSON.parse(data_aircomp);


                const airlainesList = [];

                $.each(data_aircomp, function(index, value) {
                    airlainesList.push(value);
                });

                flightSearchForm.find("#flight_search_destination").autocomplete({
                    source: destinationsList,
                    change: function(event, ui) {
                        if (ui.item == null) {
                            event.currentTarget.value = '';
                            event.currentTarget.focus();
                        }
                    }
                });
                flightSearchForm.find("#flight_search_airline").autocomplete({
                    source: airlainesList,
                    change: function(event, ui) {
                        if (ui.item == null) {
                            event.currentTarget.value = '';
                            event.currentTarget.focus();
                        }
                    }
                });

                //flight date - choose a date
                const flight_search_date = flightSearchForm.find("#flight_search_date");
                flight_search_date.datepicker({
                    changeMonth: true,
                    changeYear: true,
                    dateFormat: "dd/mm/yy",
                    minDate: "-6M",
                    maxDate: "+1Y",
                    firstDay: 1
                });

                //regex the flight date
                $.validator.addMethod(
                    "regexDateFormat",
                    function( value, element, regexp ) {
                        const re = new RegExp(regexp);
                        return this.optional(element) || re.test(value);
                    },
                    __( 'Wrong date format' ,  'sofia-airport' )
                );

                //regex the flight number
                $.validator.addMethod(
                    "regexFlightNo",
                    function( value, element ) {
                        return this.optional(element) || /^([a-zA-Z0-9]+)$/i.test(value);
                    },
                    __( 'Flight number must contain only numbers and letters' ,  'sofia-airport' )
                );

                flightSearchForm.validate({
                    rules: {
                        flight_no: {
                            require_from_group: [1, ".search-group"],
                            minlength: 2,
                            maxlength: 7,
                            regexFlightNo: true
                        },
                        flight_search_date : {
                            require_from_group: [1, ".search-group"],
                            regexDateFormat: /^(?=\d)(?:(?:31(?!.(?:0?[2469]|11))|(?:30|29)(?!.0?2)|29(?=.0?2.(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00)))(?:\x20|$))|(?:2[0-8]|1\d|0?[1-9]))([-.\/])(?:1[012]|0?[1-9])\1(?:1[6-9]|[2-9]\d)?\d\d(?:(?=\x20\d)\x20|$))?(((0?[1-9]|1[012])(:[0-5]\d){0,2}(\x20[AP]M))|([01]\d|2[0-3])(:[0-5]\d){1,2})?$/
                        },
                        arr_destination : {
                            require_from_group: [1, ".search-group"]
                        },
                        dep_destination : {
                            require_from_group: [1, ".search-group"]
                        },
                        flight_search_airline : {
                            require_from_group: [1, ".search-group"]
                        }
                    },
                    submitHandler: function( form ) {
                        form.submit();
                    }
                });

                $.extend( $.validator.messages, {
                    minlength: __( 'Wrong flight number' ,  'sofia-airport' ),
                    maxlength: __( 'Wrong flight number' ,  'sofia-airport' ),
                    require_from_group:  __( 'At least one field is required' ,  'sofia-airport' ),
                });

                //clear button
                flightSearchForm.find( "#flight_search_clear_btn" ).click(function() {
                    const search_btn = flightSearchForm.find( "#flight_search_search_btn" );

                    search_btn.attr('disable', 'true');
                    flightSearchForm.find('.flight_search_col').each( function() {
                        $(this).find('input').val('');
                        $(this).find('label.error').remove();
                    });
                    search_btn.attr('disable', 'false');
                });

            }
        }
    });
})( jQuery );